import css from './AnchorBasedContentTOC.module.css'
import { FormattedMessage } from 'react-intl';

export const privacyPolicyData = [
    {
        id: 'introduction',
        title: <FormattedMessage id="ServicePageContent.privacyPolicy.introduction.title" />,
        content: [
            <FormattedMessage
                id="ServicePageContent.privacyPolicy.introduction.content"
                values={{
                    highlight: chunks => (
                        <b className={css.highlight}>{chunks}</b>
                    ),
                }}
            />
        ],
    },
    {
        id: 'what-data-collect',
        title: <FormattedMessage id="ServicePageContent.privacyPolicy.whatDataCollect.title" />,
        content: [
            <>
                <p><FormattedMessage id="ServicePageContent.privacyPolicy.whatDataCollect.content1" /></p>
                <ul>
                    <li><FormattedMessage id="ServicePageContent.privacyPolicy.accountInfo" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /> <FormattedMessage id="ServicePageContent.privacyPolicy.accountInfoDetail" /></li>

                    <li><FormattedMessage id="ServicePageContent.privacyPolicy.profileInfo" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /> <FormattedMessage id="ServicePageContent.privacyPolicy.profileInfoDetail" /></li>

                    <li><FormattedMessage id="ServicePageContent.privacyPolicy.transactionDetails" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /> <FormattedMessage id="ServicePageContent.privacyPolicy.transactionDetailsDetail" /></li>

                    <li><FormattedMessage id="ServicePageContent.privacyPolicy.paymentData" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /> <FormattedMessage id="ServicePageContent.privacyPolicy.paymentDataDetail" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /></li>

                    <li><FormattedMessage id="ServicePageContent.privacyPolicy.communication" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /> <FormattedMessage id="ServicePageContent.privacyPolicy.communicationDetail" /></li>

                    <li><FormattedMessage id="ServicePageContent.privacyPolicy.deliveryDetails" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /> <FormattedMessage id="ServicePageContent.privacyPolicy.deliveryDetailsDetail" /></li>

                    <li><FormattedMessage id="ServicePageContent.privacyPolicy.technicalData" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /> <FormattedMessage id="ServicePageContent.privacyPolicy.technicalDataDetail" /></li>

                    <li><FormattedMessage id="ServicePageContent.privacyPolicy.verificationInfo" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /> <FormattedMessage id="ServicePageContent.privacyPolicy.verificationInfoDetail" /></li>
                </ul>
            </>
        ],
    },
    {
        id: 'why-do-we-process-this-data',
        title: <FormattedMessage id="ServicePageContent.privacyPolicy.whyProcessData.title" />,
        content: [
            <>
                <p><FormattedMessage id="ServicePageContent.privacyPolicy.whyProcessData.content" /></p>

                <ul>
                    <li><FormattedMessage id="ServicePageContent.privacyPolicy.whyProcessData.performance" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /></li>
                    <li><FormattedMessage id="ServicePageContent.privacyPolicy.whyProcessData.legitimateInterest" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /></li>
                    <li><FormattedMessage id="ServicePageContent.privacyPolicy.whyProcessData.legalObligations" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /></li>
                    <li><FormattedMessage id="ServicePageContent.privacyPolicy.whyProcessData.consent" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /></li>
                </ul>
            </>
        ]
    },
    {
        id: 'Sharing-of-data',
        title: <FormattedMessage id="ServicePageContent.privacyPolicy.sharingData.title" />,
        content: [
            <>
                <p><FormattedMessage id="ServicePageContent.privacyPolicy.sharingData.content1" /></p>
                <ul>
                    <li><FormattedMessage id="ServicePageContent.privacyPolicy.paymentHandling" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /> <FormattedMessage id="ServicePageContent.privacyPolicy.paymentHandlingDetail" /></li>
                    <li><FormattedMessage id="ServicePageContent.privacyPolicy.shippingFulfillment" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /> <FormattedMessage id="ServicePageContent.privacyPolicy.shippingFulfillmentDetail" /></li>
                    <li><FormattedMessage id="ServicePageContent.privacyPolicy.hostingItAnalytics" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /> <FormattedMessage id="ServicePageContent.privacyPolicy.hostingItAnalyticsDetail" /></li>
                    <li><FormattedMessage id="ServicePageContent.privacyPolicy.legal" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /> <FormattedMessage id="ServicePageContent.privacyPolicy.legalDetail" /></li>
                </ul>

                <p style={{ marginTop: '10px' }}><FormattedMessage values={{
                    highlight: chunks => (
                        <strong className={css.highlight}>{chunks}</strong>
                    ),
                }} id="ServicePageContent.privacyPolicy.processingAgreements" /></p>
            </>
        ],
    },
    {
        id: 'Retention-periods',
        title: <FormattedMessage id="ServicePageContent.privacyPolicy.retentionPeriods.title" />,
        content: [
            <ul>

                <li>
                    <FormattedMessage id="ServicePageContent.privacyPolicy.accountCommunicationInfo" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /> <FormattedMessage id="ServicePageContent.privacyPolicy.accountCommunicationInfoDetail" />
                </li>
                <li>
                    <FormattedMessage id="ServicePageContent.privacyPolicy.transactionalData" values={{
                        highlight: chunks => (
                            <strong className={css.highlight}>{chunks}</strong>
                        ),
                    }} /> <FormattedMessage id="ServicePageContent.privacyPolicy.transactionalDataDetail" />
                </li>
                <li>
                    <FormattedMessage id="ServicePageContent.privacyPolicy.logTechnicalData" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /> <FormattedMessage id="ServicePageContent.privacyPolicy.logTechnicalDataDetail" />
                </li>
            </ul>
        ],
    },
    {
        id: 'Your-privacy-rights',
        title: <FormattedMessage id="ServicePageContent.privacyPolicy.privacyRights.title" />,
        content: [
            <>
                <p><FormattedMessage
                    id="ServicePageContent.privacyPolicy.privacyRightsContent"
                    values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }}
                /></p>
            </>
        ],
    },
    {
        id: 'Cookies',
        title: <FormattedMessage id="ServicePageContent.privacyPolicy.cookies.title" />,
        content: [
            <>
                <p><FormattedMessage id="ServicePageContent.privacyPolicy.cookies.content1" /></p>
                <ul>
                    <li>
                        <FormattedMessage id="ServicePageContent.privacyPolicy.functionalCookies" values={{
                            highlight: chunks => (
                                <b className={css.highlight}>{chunks}</b>
                            ),
                        }} /> <FormattedMessage id="ServicePageContent.privacyPolicy.functionalCookiesDetail" />
                    </li>
                    <li>
                        <FormattedMessage id="ServicePageContent.privacyPolicy.analyticalCookies" values={{
                            highlight: chunks => (
                                <b className={css.highlight}>{chunks}</b>
                            ),
                        }} /> <FormattedMessage id="ServicePageContent.privacyPolicy.analyticalCookiesDetail" />
                    </li>
                </ul>
                <p style={{ marginTop: "10px" }}><FormattedMessage id="ServicePageContent.privacyPolicy.cookiesManagement" /></p>
            </>
        ],
    },
    {
        id: 'Security',
        title: <FormattedMessage id="ServicePageContent.privacyPolicy.security.title" />,
        content: [
            <>
                <p><FormattedMessage
                    id="ServicePageContent.privacyPolicy.securityContent"
                    values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }}
                /></p>
            </>
        ],
    },

    {
        id: 'Minors',
        title: <FormattedMessage id="ServicePageContent.privacyPolicy.minors.title" />,
        content: [
            <>
                <p><FormattedMessage
                    id="ServicePageContent.privacyPolicy.minorsContent"
                    values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }}
                /></p>
            </>
        ],
    },

    {
        id: 'Changes-to-this-Policy',
        title: <FormattedMessage id="ServicePageContent.privacyPolicy.changes.title" />,
        content: [
            <>
                <p><FormattedMessage id="ServicePageContent.privacyPolicy.changesContent" /></p>
            </>
        ],
    },

    {
        id: 'Contact',
        title: <FormattedMessage id="ServicePageContent.privacyPolicy.contact.title" />,
        content: [
            <>
                <p>
                    <FormattedMessage
                        id="ServicePageContent.privacyPolicy.contactContent"
                        values={{
                            a: chunks => (
                                <a href="/p/contact-us">{chunks}</a>
                            ),
                        }}
                    />
                </p>
            </>
        ],
    },
];

export const termNconditionData = [
    {
        id: 'Our-Service',
        title: <FormattedMessage id="ServicePageContent.terms.ourService.title" />,
        content: [
            <>
                <p>
                    <FormattedMessage id="ServicePageContent.terms.ourService.content" />
                </p>
                <p>
                    <FormattedMessage id="ServicePageContent.terms.ourService.content2" />
                </p>

            </>
        ],
    },
    {
        id: 'Introduction',
        title: <FormattedMessage id="ServicePageContent.terms.introduction.title" />,
        content: [
            <>
                <p><FormattedMessage id="ServicePageContent.terms.introduction.content" /></p>
                <p><FormattedMessage id="ServicePageContent.terms.introduction.content2" /></p>
            </>
        ],
    },
    {
        id: 'Definitions',
        title: <FormattedMessage id="ServicePageContent.terms.definitions.title" />,
        content: [
            <>
                <ul>
                    <li><strong><FormattedMessage id="ServicePageContent.terms.seller" /></strong> <FormattedMessage id="ServicePageContent.terms.sellerDefinition" /></li>
                    <li><strong><FormattedMessage id="ServicePageContent.terms.buyer" /></strong><FormattedMessage id="ServicePageContent.terms.buyerDefinition" /></li>
                    <li><strong><FormattedMessage id="ServicePageContent.terms.member" /></strong> <FormattedMessage id="ServicePageContent.terms.memberDefinition" /></li>
                    <li><strong><FormattedMessage id="ServicePageContent.terms.user" /></strong> <FormattedMessage id="ServicePageContent.terms.userDefinition" /></li>
                    <li><strong><FormattedMessage id="ServicePageContent.terms.content" /></strong> <FormattedMessage id="ServicePageContent.terms.contentDefinition" /></li>

                </ul>
            </>
        ],
    },
    {
        id: 'Product-Requirements',
        title: <FormattedMessage id="ServicePageContent.terms.productRequirement" />,
        content: [
            <>
                <ul>
                    <li><FormattedMessage id="ServicePageContent.terms.productRequirement1" /></li>
                    <li><FormattedMessage id="ServicePageContent.terms.productRequirement2" /></li>
                    <li><FormattedMessage id="ServicePageContent.terms.productRequirement3" /></li>
                    <li><FormattedMessage id="ServicePageContent.terms.productRequirement4" /></li>
                </ul>
                <p style={{ marginTop: '10px' }}><FormattedMessage id="ServicePageContent.terms.productRequirementNote" /></p>
            </>
        ],
    },
    {
        id: 'Prices-and-Sales-Practices',
        title: <FormattedMessage id="ServicePageContent.terms.pricesSalesPractices.title" />,
        content: [
            <>
                <ul>
                    <li><FormattedMessage id="ServicePageContent.terms.pricesSales1" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /></li>
                    <li><FormattedMessage id="ServicePageContent.terms.pricesSales2" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /></li>
                    <li><FormattedMessage id="ServicePageContent.terms.pricesSales3" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /></li>
                </ul>
            </>
        ],
    },
    {
        id: 'Service-Region',
        title: <FormattedMessage id="ServicePageContent.terms.serviceRegion.title" />,
        content: [
            <>
                <p><FormattedMessage
                    id="ServicePageContent.terms.serviceRegionContent"
                    values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }}
                /></p>
            </>
        ],
    },
    {
        id: 'Permitted-and-Prohibited-Uses',
        title: <FormattedMessage id="ServicePageContent.terms.permittedProhibitedUses.title" />,
        content: [
            <>
                <p><FormattedMessage id="ServicePageContent.terms.permittedProhibitedContent1" /></p>
                <ul>
                    <li><FormattedMessage id="ServicePageContent.terms.permittedProhibited1" /></li>
                    <li><FormattedMessage id="ServicePageContent.terms.permittedProhibited2" /></li>
                    <li><FormattedMessage id="ServicePageContent.terms.permittedProhibited3" /></li>
                </ul>
                <p><FormattedMessage id="ServicePageContent.terms.permittedProhibitedNote" /></p>
            </>
        ],
    },
    {
        id: 'Taxes',
        title: <FormattedMessage id="ServicePageContent.terms.taxes.title" />,
        content: [
            <>
                <ul>
                    <li><FormattedMessage id="ServicePageContent.terms.taxes1" /></li>
                    <li><FormattedMessage id="ServicePageContent.terms.taxes2" /></li>
                    <li><FormattedMessage id="ServicePageContent.terms.taxes3" /></li>
                </ul>
            </>
        ],
    },
    {
        id: 'Copyright',
        title: <FormattedMessage id="ServicePageContent.terms.copyright.title" />,
        content: [
            <>
                <ul>
                    <li><FormattedMessage id="ServicePageContent.terms.copyright1" /></li>
                    <li><FormattedMessage id="ServicePageContent.terms.copyright2" /></li>
                    <li><FormattedMessage id="ServicePageContent.terms.copyright3" /></li>
                </ul>
            </>
        ],
    },
    {
        id: 'Refusal-and-Termination-of-Service',
        title: <FormattedMessage id="ServicePageContent.terms.refusalTermination.title" />,
        content: [
            <>
                <p><FormattedMessage id="ServicePageContent.terms.refusalTerminationContent" /></p>
            </>
        ],
    },
    {
        id: 'Disputes-and-Liability',
        title: <FormattedMessage id="ServicePageContent.terms.disputesLiability.title" />,
        content: [
            <>
                <ul>
                    <li><FormattedMessage id="ServicePageContent.terms.disputesLiability1" /></li>
                    <li><FormattedMessage id="ServicePageContent.terms.disputesLiability2" /></li>
                    <li><FormattedMessage id="ServicePageContent.terms.disputesLiability3" /></li>
                    <li><FormattedMessage id="ServicePageContent.terms.disputesLiability4" /></li>
                </ul>
            </>
        ],
    },
    {
        id: 'Promotions',
        title: <FormattedMessage id="ServicePageContent.terms.promotions.title" />,
        // title: 'Promotions',
        content: [
            <>
                <p><FormattedMessage id="ServicePageContent.terms.promotionsContent" /></p>
            </>
        ],
    },
]


export const InformationForSellerData = [
    {
        id: 'Selling-on-GrooveBay',
        title: <FormattedMessage id="ServicePageContent.sellers.selling.title" />,
        content: [
            <>
                <p><FormattedMessage id="ServicePageContent.sellers.selling.content" /></p>
                <p><FormattedMessage id="ServicePageContent.sellers.selling.content2" /></p>
                <p><FormattedMessage id="ServicePageContent.sellers.selling.content3" /></p>
            </>
        ],
    },
    {
        id: 'Pricing-and-commission',
        title: <FormattedMessage id="ServicePageContent.sellers.pricingCommission.title" />,
        content: [
            <>
                <p>
                    <FormattedMessage id="ServicePageContent.sellers.pricingCommission.content" />
                </p>
                <ul>
                    <li>
                        <FormattedMessage id="ServicePageContent.sellers.commission" values={{
                            highlight: chunks => (
                                <b className={css.highlight}>{chunks}</b>
                            ),
                        }} />
                    </li>
                    <li><FormattedMessage id="ServicePageContent.sellers.commissionAuto" /></li>
                    <li><FormattedMessage id="ServicePageContent.sellers.remainingAmount" /></li>
                    <li><FormattedMessage id="ServicePageContent.sellers.noFixedFees" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /></li>
                </ul>
            </>
        ],
    },
    {
        id: 'Listings',
        title: <FormattedMessage id="ServicePageContent.sellers.listings.title" />,
        content: [
            <>
                <p><FormattedMessage id="ServicePageContent.sellers.listings.content" /></p>
                <ul>
                    <li><FormattedMessage id="ServicePageContent.sellers.listingRequirement1" /></li>
                    <li><FormattedMessage id="ServicePageContent.sellers.listingRequirement2" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /></li>
                    <li><FormattedMessage id="ServicePageContent.sellers.listingRequirement3" /></li>
                    <li><FormattedMessage id="ServicePageContent.sellers.listingRequirement4" /></li>
                </ul>
                <p><FormattedMessage id="ServicePageContent.sellers.listingNote" /></p>
            </>
        ],
    },
    {
        id: 'Shipping-and-Delivery',
        title: <FormattedMessage id="ServicePageContent.sellers.shippingDelivery.title" />,
        content: [
            <>
                <p><FormattedMessage id="ServicePageContent.sellers.shippingDelivery.content" /></p>
                <ul>
                    <li><FormattedMessage id="ServicePageContent.sellers.shipWithin" values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }} /></li>
                    <li><FormattedMessage id="ServicePageContent.sellers.shippingCosts" /></li>
                    <li><FormattedMessage id="ServicePageContent.sellers.shippingMethods" /></li>
                    <li><FormattedMessage id="ServicePageContent.sellers.packagingResponsibility" /></li>
                </ul>
            </>
        ],
    },
    {
        id: 'Payout-of-sales-proceeds',
        title: <FormattedMessage id="ServicePageContent.sellers.payout.title" />,
        content: [
            <>
                <p><FormattedMessage id="ServicePageContent.sellers.payout.content" /></p>
                <ul>
                    <li><FormattedMessage id="ServicePageContent.sellers.fundsHeld" /></li>
                    <li><FormattedMessage id="ServicePageContent.sellers.autoPayout" /></li>
                    <li><FormattedMessage id="ServicePageContent.sellers.bankTransfer" /></li>
                    <li><FormattedMessage id="ServicePageContent.sellers.paymentMethods" /></li>
                </ul>
            </>
        ],
    },
    {
        id: 'General-provisions',
        title: <FormattedMessage id="ServicePageContent.sellers.generalProvisions.title" />,
        content: [
            <>
                <p><FormattedMessage
                    id="ServicePageContent.sellers.generalProvisions.content"
                    values={{
                        highlight: chunks => (
                            <a target='_blank' href='/p/terms-of-service' className={css.highlight}>{chunks}</a>
                        ),
                    }}
                /></p>
            </>
        ],
    },
    {
        id: 'How-cancel',
        title: <FormattedMessage id="ServicePageContent.sellers.cancelOrder.title" />,
        content: [
            <>
                <p><FormattedMessage id="ServicePageContent.sellers.cancelOrder.content1" /></p>
                <p><FormattedMessage id="ServicePageContent.sellers.cancelOrder.content2" /></p>
                <p><FormattedMessage id="ServicePageContent.sellers.cancelOrder.content3" values={{
                    highlight: chunks => (
                        <a target='_blank' href='/p/contact-us' className={css.highlight}>{chunks}</a>
                    ),
                }} /></p>
                <p className={css.cancelOrdersContent4}><FormattedMessage id="ServicePageContent.sellers.cancelOrder.content4" /></p>
                <p><FormattedMessage id="ServicePageContent.sellers.cancelOrder.content5" /></p>
            </>
        ],
    },
]

export const InformationForBuyerData = [
    {
        id: 'Purchasing-on-GrooveBay',
        title: <FormattedMessage id="ServicePageContent.buyers.purchasing.title" />,
        content: [
            <>
                <p>
                    <FormattedMessage id="ServicePageContent.buyers.purchasing.content" />
                </p>
                <p>
                    <FormattedMessage id="ServicePageContent.buyers.purchasing.content2" />
                </p>
                <p>
                    <FormattedMessage id="ServicePageContent.buyers.purchasing.content3" />
                </p>
            </>
        ],
    },

    {
        id: 'Refunds-and-replacements',
        title: <FormattedMessage id="ServicePageContent.buyers.refundsReplacements.title" />,
        content: [
            <>
                <p>
                    <FormattedMessage
                        id="ServicePageContent.buyers.refundsReplacements.content"
                        values={{
                            highlight: chunks => (
                                <b className={css.highlight}>{chunks}</b>
                            ),
                        }}
                    />
                </p>
                <ul>
                    <li><FormattedMessage id="ServicePageContent.buyers.refundsReplacements.list1" /></li>
                    <li><FormattedMessage id="ServicePageContent.buyers.refundsReplacements.list2" /></li>
                    <li><FormattedMessage id="ServicePageContent.buyers.refundsReplacements.list3" /></li>
                </ul>

                <p>
                    <FormattedMessage id="ServicePageContent.buyers.refundsReplacements.reportIssue" />
                </p>

                <p>
                    <FormattedMessage
                        id="ServicePageContent.buyers.refundsReplacements.returnPeriod"
                        values={{
                            highlight: chunks => (
                                <strong className={css.highlight}>{chunks}</strong>
                            ),
                        }}
                    />
                </p>

            </>
        ],
    },
    {
        id: 'Product-care',
        title: <FormattedMessage id="ServicePageContent.buyers.productCare.title" />,
        content: [
            <>
                <p><FormattedMessage id="ServicePageContent.buyers.productCare.content" /></p>
                <p><FormattedMessage
                    id="ServicePageContent.buyers.productCare.content2"
                    values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }}
                /></p>

            </>
        ],
    },
    {
        id: 'Shipping-information',
        title: <FormattedMessage id="ServicePageContent.buyers.shippingInformation.title" />,
        content: [
            <>
                <p><FormattedMessage
                    id="ServicePageContent.buyers.shippingInformation.content"
                    values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }}
                />
                </p>
                <ul>
                    <li><FormattedMessage id="ServicePageContent.buyers.shippingInfo.trackingNumber" /></li>
                    <li><FormattedMessage id="ServicePageContent.buyers.shippingInfo.notResponsible" /></li>
                    <li><FormattedMessage id="ServicePageContent.buyers.shippingInfo.signatureRisk" /></li>
                    <li><FormattedMessage id="ServicePageContent.buyers.shippingInfo.shippingCosts" /></li>
                    <li><FormattedMessage id="ServicePageContent.buyers.shippingInfo.availableMethods" /></li>
                    <li><FormattedMessage id="ServicePageContent.buyers.shippingInfo.carrierChoice" /></li>
                </ul>
            </>
        ],
    },
    {
        id: 'Service-region',
        title: <FormattedMessage id="ServicePageContent.buyers.serviceRegion.title" />,
        content: [
            <>
                <p > <FormattedMessage
                    id="ServicePageContent.buyers.serviceRegionContent"
                    values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }}
                /></p >
            </>
        ],
    },
    {
        id: 'Pricing',
        title: <FormattedMessage id="ServicePageContent.buyers.pricing.title" />,
        content: [
            <>
                <p><FormattedMessage
                    id="ServicePageContent.buyers.pricingContent"
                    values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }}
                /></p>
                <p><FormattedMessage
                    id="ServicePageContent.buyers.pricing.platformFee"
                    values={{
                        highlight: chunks => (
                            <b className={css.highlight}>{chunks}</b>
                        ),
                    }}
                /></p>
            </>
        ],
    },
    {
        id: 'Cancelorders',
        title: <FormattedMessage id="ServicePageContent.buyers.cancelOrders.title" />,
        content: [
            <>
                <p className={css.cancelOrdersContent1}><FormattedMessage id="ServicePageContent.buyers.cancelOrders.content1" /></p>
                <p className={css.cancelOrdersContent2}><FormattedMessage id="ServicePageContent.buyers.cancelOrders.content2" /></p>
                <p className={css.cancelOrdersContent3}><FormattedMessage id="ServicePageContent.buyers.cancelOrders.content3" values={{
                    highlight: chunks => (
                        <b className={css.highlight}>{chunks}</b>
                    ),
                }} /></p>
                <p className={css.cancelOrdersContent4}><FormattedMessage id="ServicePageContent.buyers.cancelOrders.content4" /></p>
                <p className={css.cancelOrdersContent5}><FormattedMessage id="ServicePageContent.buyers.cancelOrders.content5" /></p>
            </>
        ],
    },
]